import { Box, Grid } from "@mui/material";
import { PostInfo } from "./types";

const styles = {
  imageWrapper: {
    width: "3.875rem",
    height: "3.875rem",
    mx: "0.375rem",
    position: "relative",
    "& img": {
      borderRadius: "6px",
      objectFit: "cover",
    },
  },
  imageCount: {
    position: "absolute",
    backgroundColor: "rgba(0,0,0,.4)",
    color: "white",
    fontSize: "0.6rem",
    top: "0.45em",
    right: "0.45em",
    borderRadius: "1.34em",
    padding: "0.335em 0.45em",
    lineHeight: "1em",
  },
  imageGif: {
    position: "absolute",
    color: "white",
    fontSize: "0.75rem",
    fontWeight: "bold",
    bottom: "0.5em",
    left: "0.5em",
  },
};

interface CafeCardImageProps {
  row: PostInfo;
}

export function CafeCardImage({ row }: CafeCardImageProps) {
  const { image, imageCount, isGif } = row;
  const imageMoreCount = imageCount - 1;

  return (
    <Grid item sx={styles.imageWrapper}>
      {image && (
        <>
          <img src={image} alt="" width="100%" height="100%" />
          {imageMoreCount > 0 && (
            <Box sx={styles.imageCount}>{Math.min(imageMoreCount, 9)}+</Box>
          )}
          {!!isGif && <Box sx={styles.imageGif}>GIF</Box>}
        </>
      )}
    </Grid>
  );
}
